const getFormattedKey = (
  key,
  options = { withTimestamp: false, withPrefix: null },
) => {
  const { withTimestamp, withPrefix } = options;
  let formattedKey = key;
  if (withTimestamp) {
    formattedKey = key.split('_');
    formattedKey.splice(1, 0, 'timestamp');
    formattedKey = formattedKey.join('_');
  }
  if (withPrefix) formattedKey = `${withPrefix}_${formattedKey}`;
  // console.log('formatted key', formattedKey);
  return formattedKey;
};

const storeUTMParam = (
  key,
  value,
  options = { shouldOverwrite: true, withPrefix: null, withTimestamp: true },
) => {
  const basicKey = getFormattedKey(key, { withPrefix: options.withPrefix });

  if (!localStorage.getItem(basicKey) || options.shouldOverwrite) {
    console.log(`Storing ${basicKey} as ${value}`);
    // Create this item
    localStorage.setItem(basicKey, value);

    // Also store a timestamp version if needed. We assume this doesn't exist if the non-timestamp version doesn't either since we can't make timestamp entries without also making non-timestamp entries.

    if (options.withTimestamp) {
      console.log(`Creating timestamp version`);
      const timestampKey = getFormattedKey(key, {
        withPrefix: options.withPrefix,
        withTimestamp: true,
      });

      // store the item
      localStorage.setItem(timestampKey, new Date());
    }
  } else {
    console.log(`${basicKey} already exists`);
  }
};

export const pushToElqQ = () => {
  // eslint-disable-next-line no-underscore-dangle
  const _elqQ = window._elqQ || [];
  _elqQ.push(['elqSetSiteId', '1017189481']);
  _elqQ.push(['elqUseFirstPartyCookie', 'elqjourney.pwc.com']);
  _elqQ.push(['elqTrackPageView']);
};

export const PARAM_KEYS = [
  // 'utm_vip'
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_offer',
  'utm_term',
  'cid'
];

export const elqGetGUIDValue = (initialValue, subKey) => {
  if (initialValue == null || initialValue == '') return '';
  var cookieGUIDValue = initialValue.split('&');
  for (var i = 0; i < cookieGUIDValue.length; i++) {
    var pair = cookieGUIDValue[i].split('=');
    if (pair.length > 1) {
      if (pair[0] == subKey) {
        return pair[1];
      }
    }
  }
  return '';
};

export const getValuesFromLocalStorageByKey = (keys) =>
  Object.fromEntries(
    keys.reduce((acc, cv) => {
      const lsVal = localStorage.getItem(cv);
      // console.log(`Getting ${cv}: ${lsVal}`);
      if (lsVal !== null) {
        return [...acc, [cv, lsVal]];
      }
      return acc;
    }, []),
  );

export const storeUTMParams = () => {
  // console.log('STORING UTM PARAMS');
  // Example URL
  // http://localhost:8001/?utm_vip=foo&utm_medium=bar&utm_source=baz&utm_campaign=bat&utm_offer=bam&utm_term=baf

  // Step through the params looking for any of these.
  // We handle UTM_VIP differently below.

  const params = new URLSearchParams(document.location.search.substring(1));

  // For each of the above, store them with appropriate prefixing and timestamping.

  PARAM_KEYS.forEach((key) => {
    // console.log(`Looking for ${key}`);
    if (params.get(key)) {
      // Store a prefixed as well as a prefixed and timestamped version e.g. 'first_utm_vip' and 'first_urm_timestamp_vip';
      storeUTMParam(key, params.get(key), {
        shouldOverwrite: false, // we don't want to overwrite our first visits
        withPrefix: 'first',
        withTimestamp: true,
      });

      // Then store a plain version of it, safe to overwrite it.
      storeUTMParam(key, params.get(key), {
        shouldOverwrite: true,
        withTimestamp: true,
      });
    } else {
      // console.log(`${key} not found on current URL`);
    }
  });

  // We store utm_vip as utm_cookie_status instead
  if (params.get('utm_vip')) {
    // This is what we'll store utm_vip as.
    const rewriteKey = 'utm_cookie_status';

    // Make the 'first' and timestamp versions.
    storeUTMParam(rewriteKey, params.get('utm_vip'), {
      shouldOverwrite: false,
      withPrefix: 'first',
      withTimestamp: true,
    });

    // Then store a plain version of it, safe to overwrite it.
    storeUTMParam(rewriteKey, params.get('utm_vip'), {
      shouldOverwrite: true,
      withTimestamp: true,
    });
  }
};
